
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articoli/[slug]",
      function () {
        return require("private-next-pages/articoli/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articoli/[slug]"])
      });
    }
  